var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 19.815v.999c0 .556.447 1 .999 1H17a1 1 0 0 0 .999-1V6.816A.997.997 0 0 0 17 5.815h-1v-1h1.008c1.1 0 1.992.892 1.992 1.995v14.01a1.995 1.995 0 0 1-1.992 1.995H5.992c-1.1 0-1.992-.893-1.992-1.995v-1.005zm8.008-19c1.1 0 1.992.892 1.992 1.995v14.01a1.995 1.995 0 0 1-1.992 1.995H1.992C.892 18.815 0 17.922 0 16.82V2.81C0 1.708.893.815 1.992.815zm-.007 1H2a1 1 0 0 0-.999 1v13.999c0 .556.447 1 .999 1h11a1 1 0 0 0 .999-1V2.816A.997.997 0 0 0 13 1.815zm-5.501 12c.245 0 .45.183.492.412l.008.088c0 .245-.183.45-.412.492l-.088.008a.505.505 0 0 1-.5-.5c0-.246.183-.45.412-.492zm.5-8v7H7v-7z"
  })));
});
const SvgDuplicateIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDuplicateIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAxOSAyMyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik01IDE5LjgxNXYuOTk5YzAgLjU1Ni40NDcgMSAuOTk5IDFIMTdhMSAxIDAgMCAwIC45OTktMVY2LjgxNmMwLS41NTctLjQ0Ny0xLjAwMS0uOTk5LTEuMDAxSDE2di0xaDEuMDA4YzEuMSAwIDEuOTkyLjg5MiAxLjk5MiAxLjk5NXYxNC4wMWExLjk5NSAxLjk5NSAwIDAgMS0xLjk5MiAxLjk5NUg1Ljk5MmMtMS4xIDAtMS45OTItLjg5My0xLjk5Mi0xLjk5NXYtMS4wMDVoMXptOC4wMDgtMTljMS4xIDAgMS45OTIuODkyIDEuOTkyIDEuOTk1djE0LjAxYTEuOTk1IDEuOTk1IDAgMCAxLTEuOTkyIDEuOTk1SDEuOTkyQy44OTIgMTguODE1IDAgMTcuOTIyIDAgMTYuODJWMi44MUMwIDEuNzA4Ljg5My44MTUgMS45OTIuODE1aDExLjAxNnptLS4wMDcgMUgyYTEgMSAwIDAgMC0uOTk5IDF2MTMuOTk5YzAgLjU1Ni40NDcgMSAuOTk5IDFIMTNhMSAxIDAgMCAwIC45OTktMVYyLjgxNmMwLS41NTctLjQ0Ny0xLjAwMS0uOTk5LTEuMDAxem0tNS41MDEgMTJjLjI0NSAwIC40NS4xODMuNDkyLjQxMmwuMDA4LjA4OGMwIC4yNDUtLjE4My40NS0uNDEyLjQ5MmwtLjA4OC4wMDhhLjUwNS41MDUgMCAwIDEtLjUtLjVjMC0uMjQ2LjE4My0uNDUuNDEyLS40OTJsLjA4OC0uMDA4em0uNS04djdIN3YtN2gxeiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg==";